/* Reviews split carousel: single-review-at-a-time slider with
   circular prev/next buttons and swipe support. Self-contained,
   scoped to [data-reviews-carousel] so it cannot affect any other
   theme slider. */
(function () {
  function initCarousel(root) {
    if (root.dataset.reviewsInit === 'true') return;
    root.dataset.reviewsInit = 'true';

    var track = root.querySelector('[data-reviews-track]');
    var slides = root.querySelectorAll('[data-reviews-slide]');
    var prevBtn = root.querySelector('[data-reviews-prev]');
    var nextBtn = root.querySelector('[data-reviews-next]');
    var count = slides.length;
    if (!track || count === 0) return;

    var index = 0;

    function update() {
      track.style.transform = 'translateX(-' + index * 100 + '%)';
    }

    function goTo(newIndex) {
      index = ((newIndex % count) + count) % count;
      update();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    if (count <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }

    var startX = null;
    var dragging = false;

    root.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      dragging = true;
    });
    root.addEventListener('pointerup', function (e) {
      if (!dragging || startX === null) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 40) {
        if (delta < 0) {
          goTo(index + 1);
        } else {
          goTo(index - 1);
        }
      }
      dragging = false;
      startX = null;
    });
    root.addEventListener('pointercancel', function () {
      dragging = false;
      startX = null;
    });

    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goTo(index - 1);
      if (e.key === 'ArrowRight') goTo(index + 1);
    });

    update();
  }

  function initAll(scope) {
    var context = scope || document;
    var roots = context.querySelectorAll('[data-reviews-carousel]');
    for (var i = 0; i < roots.length; i++) {
      initCarousel(roots[i]);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();